export enum labRecordType {
  UNIFIED_LAB_RECORD_TYPE_UNSPECIFIED = 0,
  UNIFIED_LAB_RECORD_TYPE_LEGACY_LAB = 1,
  UNIFIED_LAB_RECORD_TYPE_PREVIOUS_PROVIDER = 2,
}
